import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaDownload, FaServer } from "react-icons/fa";

interface Product {
    user_product_id: string;
    product_id: string;
    title: string;
    main_image: string;
    download_link: string;
}

const UserProducts: React.FC = () => {
    const [products, setProducts] = useState<Product[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/user-products`, { credentials: 'include' })
            .then((response) => response.json())
            .then((data) => setProducts(data))
            .catch((error) => console.error('Error fetching products:', error));
    }, []);

    return (
        <div className="flex flex-wrap gap-8 justify-center">
            {products.length === 0 ? (
                <div className="text-center text-2xl text-slate-400 mt-3 uppercase font-bold" style={{ fontFamily: 'Montserrat, serif' }}>
                    Nothing Found 😿
                </div>
            ) : (
            products.map((product) => (
                <div key={product.user_product_id} className="relative w-[290px] h-[370px] bg-gradient-to-r from-slate-700 to-gray-700 p-2 rounded-md shadow-xl flex flex-col justify-between">
                    <img src={product.main_image} alt={product.title} className="w-full object-cover rounded" />
                    <h3 className="text-xl font-bold text-center text-slate-100"
                            style={{ fontFamily: 'Tektur, serif' }}>{product.title}</h3>
                    <div className="flex justify-between">
                        <a href={product.download_link} className="bg-green-700 px-4 py-2 text-white w-[calc(48%)] rounded text-center flex flex-row gap-2 justify-center shadow-lg hover:shadow-[0_0_10px_2px_rgba(21,128,61,0.5)] transition">
                        <FaDownload size={18}/><p className='font-bold' style={{ fontFamily: 'Montserrat, sans-serif' }}>Download</p>
                        </a>
                        <button
                            className="bg-red-800 px-4 py-2 text-white w-[calc(48%)] rounded text-center flex flex-row gap-2 justify-center shadow-lg hover:shadow-[0_0_10px_2px_rgba(203,27,27,0.5)] transition"
                            onClick={() => navigate(`/protection/${product.product_id}`, { state: { product_id: product.product_id } })}
                        >
                            <FaServer size={18} />
                            <p className="font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>IP</p>
                        </button>
                    </div>
                </div>
            ))
        )}
        </div>
    );
};

export default UserProducts;